export type Response = {
  message: string;
};

export default async function fetcher<T>(
  url: string,
  options?: RequestInit,
): Promise<T | Response> {
  try {
    const response = await fetch(url, options || {});

    if (!response.ok) {
      const errorPayload = await response.json();
      throw new Error(errorPayload);
    }
    const data = (await response.json()) as T;

    return data;
  } catch (error: any) {
    return {
      message: 'error',
    };
  }
}
